export const queryLoopFilters = async (err) => {
  if (err) {
    console.error(err);
  }

  // Your query loop filter logic here

  /*
   * Filter assistants day blockPostItems by category
   */
  const queryLoopFilter = document.querySelectorAll(
    '.query-loop-cat-filters .cat-item',
  );
  if (queryLoopFilter) {
    const showAllItemsListElement = document.createElement('li');
    const showAlltemsLink = document.createElement('a');
    showAllItemsListElement.classList.add(
      'cat-item',
      'show-all-items',
      'active',
    );

    showAlltemsLink.setAttribute('href', '#');
    showAlltemsLink.innerText = 'Alle anzeigen';

    showAllItemsListElement.appendChild(showAlltemsLink);

    if (document.querySelector('.query-loop-cat-filters')) {
      document
        .querySelector('.query-loop-cat-filters')
        .prepend(showAllItemsListElement);
    }

    document.addEventListener('click', function (e) {
      if (e.target.closest('.query-loop-cat-filters .cat-item')) {
        e.preventDefault();
        var filter = e.target.closest('.query-loop-cat-filters .cat-item');

        queryLoopFilter.forEach((f) => {
          f.classList.remove('active');
        });

        showAllItemsListElement.classList.remove('active');

        filter.classList.add('active');

        var allItems = '';
        // set active class on filter
        allItems = document.querySelectorAll(
          '.query-loop .wp-block-query .wp-block-post',
        );
        // alle-anzeigen
        if (filter.classList.contains('show-all-items')) {
          allItems.forEach((blockPostItem) => {
            blockPostItem.style.display = 'grid';
          });
          showAllItemsListElement.classList.add('active');
        } else {
          console.log(filter);

          allItems.forEach((blockPostItem) => {
            blockPostItem.style.display = 'none';
          });

          var filterValueClass =
            'posttype-kategorie-' + filter.textContent.toLowerCase();

          var filteredQueryLoopItems = document.querySelectorAll(
            '.' + filterValueClass,
          );
          filteredQueryLoopItems.forEach((filteredQueryLoopItem) => {
            filteredQueryLoopItem.style.display = 'grid';
          });
        }
      }
    });
  }
};

import.meta.webpackHot?.accept(queryLoopFilters);
